module.exports = "/_next/static/images/plank-0a9f74bfd2351d9bb95ab3e35209a62f.jp2";